import { useMemo } from 'react';
import { useOxygen } from '../providers';
import { getAllProjectAssignees } from '../helpers';
import { EMPTY_ARRAY } from '../constants';
import { Assignee } from '../sdk';

/** This hook returns assignees for the project and loading state:
 * 1. All users in the project including deleted ones
 * 2. All companies in the project that contain members
 * 3. All roles in the project that contain members
 */
export const useProjectAssignees = () => {
  const oxygen = useOxygen();

  return useMemo(
    () => ({
      loading: oxygen.loading,
      allProjectAssignees: oxygen.loading
        ? (EMPTY_ARRAY as Assignee[])
        : getAllProjectAssignees(oxygen),
    }),
    [oxygen, oxygen.loading],
  );
};
